import React from "react";

export const LinkResource = ({ resource }) => {
    return <div className={'resource'}>
        <a className={'link'} href={resource.url}>{resource.text}</a>
    </div >
}
